module.exports = __webpack_public_path__ + "img/team4.3ae4b64b.png";